import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

class Sidebar extends Component {

  state = {};

  toggleMenuState(menuState) {
    if (this.state[menuState]) {
      this.setState({[menuState] : false});
    } else if(Object.keys(this.state).length === 0) {
      this.setState({[menuState] : true});
    } else {
      Object.keys(this.state).forEach(i => {
        this.setState({[i]: false});
      });
      this.setState({[menuState] : true});
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    document.querySelector('#sidebar').classList.remove('active');
    Object.keys(this.state).forEach(i => {
      this.setState({[i]: false});
    });

  
 
  }

  render () {
 
console.log(this.props)
   
    return (
      <nav className="sidebar sidebar-offcanvas" id="sidebar">
       
        <ul className="nav">
         
        <li className={ this.isPathActive('/dashboard') ? 'nav-item active' : 'nav-item' }>
           <Link className="nav-link" to="/dashboard">
             <i className="mdi mdi-home menu-icon"></i>
             <span className="menu-title">Dashboard</span>
           </Link>
         </li>
      
      
        
         <li className={ this.isPathActive('/master') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/master">
              <i className="mdi mdi-file menu-icon"></i>
              <span className="menu-title">Training Program Master</span>
            </Link>
          </li> 
         <li className={ this.isPathActive('/planner') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/planner">
              <i className="mdi mdi-clipboard menu-icon"></i>
              <span className="menu-title">Training Planner</span>
            </Link>
          </li> 
     
    
      <li className={ this.isPathActive('/attendance') ? 'nav-item active' : 'nav-item' }>
          <Link className="nav-link" to="/attendance">
            <i className="mdi mdi-account menu-icon"></i>
            <span className="menu-title">Training Attendance</span>
          </Link>
        </li>
        <li className={ this.isPathActive('/reports') ? 'nav-item active' : 'nav-item' }>
          <Link className="nav-link" to="/reports">
            <i className="menu-icon mdi mdi-table"></i>
            <span className="menu-title">Classroom Reports</span>
          </Link>
        </li>
        {(localStorage.getItem('access_token') || '').startsWith('17453') && (
          <li className={ this.isPathActive('/scheduleprogramdurationmismatch') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/scheduleprogramdurationmismatch">
              <i className="menu-icon mdi mdi-alert-circle-outline"></i>
              <span className="menu-title">Duration Mismatch</span>
            </Link>
          </li>
        )}
        {/* <li className={ this.isPathActive('/groups') ? 'nav-item active' : 'nav-item' }>
          <Link className="nav-link" to="/groups">
            <i className="mdi mdi-account-multiple menu-icon"></i>
            <span className="menu-title">Groups</span>
          </Link>
        </li> */}
     
       
          
          {/* <li className={ this.isPathActive('/vessels') ? 'nav-item active' : 'nav-item' }>
          <Link className="nav-link" to="/vessels">
            <i className="mdi mdi-priority-high  menu-icon"></i>
            <span className="menu-title">Vessels</span>
          </Link>
        </li> */}
        {/* <li className={ this.isPathActive('/permit') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/permit">
              <i className="mdi mdi-playlist-check menu-icon"></i>
              <span className="menu-title">Permit Library</span>
            </Link>
          </li> <li className={ this.isPathActive('/documents') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/documents">
              <i className="mdi mdi-file-document menu-icon"></i>
              <span className="menu-title">Document Library</span>
            </Link>
          </li> */}
          
         
     
     
          {/* <li className={ this.isPathActive('/asset') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/asset">
              <i className="mdi mdi-wrench  menu-icon"></i>
              <span className="menu-title">Asset Management</span>
            </Link>
          </li>

          <li className={ this.isPathActive('/move') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/move">
              <i className="mdi mdi-priority-high  menu-icon"></i>
              <span className="menu-title">Relocate Assets</span>
            </Link>
          </li> */}
         

         
         
          

          

        </ul>
      </nav>
    );
  }

  isPathActive(path) {
    return this.props.location.pathname.startsWith(path);
  }

  componentDidMount() {
    this.onRouteChanged();
    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    const body = document.querySelector('body');
    document.querySelectorAll('.sidebar .nav-item').forEach((el) => {
      
      el.addEventListener('mouseover', function() {
        if(body.classList.contains('sidebar-icon-only')) {
          el.classList.add('hover-open');
        }
      });
      el.addEventListener('mouseout', function() {
        if(body.classList.contains('sidebar-icon-only')) {
          el.classList.remove('hover-open');
        }
      });
    });
  }

}
const mapStateToProps=state=>{
  return{
    data:state.details
  }

}
export default connect(mapStateToProps) (withRouter(Sidebar));
